import { clsx } from 'clsx'
import styles from './Tabs.module.css'

export type TabItem = {
  id: string
  label: string
  /** Optional trailing count — "12", "3". */
  count?: number
}

type TabsProps = {
  items: TabItem[]
  activeId: string
  onSelect: (id: string) => void
  /** Names the tab group for screen readers, e.g. "Competições". */
  label: string
  className?: string | undefined
}

/**
 * Underline tabs. Scrolls horizontally rather than wrapping — a player in six
 * competitions still gets one clean row.
 */
export function Tabs({ items, activeId, onSelect, label, className }: TabsProps) {
  return (
    <div className={clsx(styles.tabs, className)} role="tablist" aria-label={label}>
      {items.map((item) => {
        const isActive = item.id === activeId
        return (
          <button
            key={item.id}
            type="button"
            role="tab"
            aria-selected={isActive}
            className={clsx(styles.tab, isActive && styles.isActive)}
            onClick={() => onSelect(item.id)}
          >
            {item.label}
            {item.count !== undefined && <span className={styles.count}>{item.count}</span>}
          </button>
        )
      })}
    </div>
  )
}
